import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Formik } from 'formik'
import * as Yup from 'yup'

import { RenewalGroupHealthPlanInformationDTO, RenewalGroupHealthPlanInformationFormDTO } from 'core'

import { Col, DefaultInput, DefaultSelect, Input, Row } from 'common/components'
import { parseZoneMonthYearDashFormat } from 'common/dateFormatters'

interface EditGroupHealthPlanInformationProps {
  groupHealthPlanInformation: RenewalGroupHealthPlanInformationDTO
  setGhpValues: (values: RenewalGroupHealthPlanInformationFormDTO) => void
  setGhpFormIsValid: (value: boolean) => void
}

const formValidator = (translate: any) =>
  Yup.object({
    planName: Yup.string().trim().required(translate('general.required')).typeError(translate('general.required')),
    insuranceCarrier: Yup.string()
      .trim()
      .required(translate('general.required'))
      .typeError(translate('general.required')),
    waitingPeriod: Yup.number()
      .required(translate('general.required'))
      // .oneOf([0, 1])
      .typeError(translate('general.required')),
  })

const GroupHealthPlanInformation: React.FC<EditGroupHealthPlanInformationProps> = ({
  groupHealthPlanInformation,
  setGhpValues,
  setGhpFormIsValid,
}) => {
  const [waitingPeriodValue, setWaitingPeriodValue] = useState<number>(0)
  const { t: translate } = useTranslation()

  const waitingPeriodOptions = [
    {
      id: 0,
      name: 'No waiting Period',
    },
    {
      id: 30,
      name: '30 days',
    },
    {
      id: 60,
      name: '60 days',
    },
    {
      id: 90,
      name: '90 days',
    },
  ]
  const groupHealthPlanInformationDefaultValues: RenewalGroupHealthPlanInformationFormDTO = {
    id: groupHealthPlanInformation.id,
    startDate: groupHealthPlanInformation.startDate,
    endDate: groupHealthPlanInformation.endDate,
    planName: groupHealthPlanInformation.planName,
    insuranceCarrier: groupHealthPlanInformation.insuranceCarrier,
    waitingPeriod: groupHealthPlanInformation.waitingPeriod,
  }

  return (
    <Formik
      enableReinitialize={true}
      validationSchema={formValidator(translate)}
      initialValues={groupHealthPlanInformationDefaultValues}
      onSubmit={() => {}}
      validate={(values) => {
        console.log(values)
        formValidator(translate).isValidSync(values)
        setGhpFormIsValid(formValidator(translate).isValidSync(values))
        setGhpValues(values)
        return {}
      }}
    >
      {(formik) => (
        <form onSubmit={formik.handleSubmit} id="groupHealthPlanInformationForm" autoComplete="off">
          <Row>
            <Col xs={10} offset={6}>
              <DefaultInput
                className={'w-100'}
                label={translate('admin-signup.company-details.health-plan.start-date-label')}
                name="startDate"
                value={parseZoneMonthYearDashFormat(formik.values.startDate)}
                disabled={true}
              />
            </Col>
          </Row>

          <Row>
            <Col xs={10} offset={6}>
              <Input
                label={translate('admin-signup.company-details.health-plan.insurance-carrier-label')}
                name="insuranceCarrier"
                placeholder={translate('admin-signup.company-details.health-plan.insurance-carrier-placeholder')}
              />
            </Col>
          </Row>

          <Row>
            <Col span={10} offset={6}>
              <Input
                label={translate('admin-signup.company-details.health-plan.insurance-plan-label')}
                name="planName"
                placeholder={translate('admin-signup.company-details.health-plan.insurance-plan-placeholder')}
              />
            </Col>
          </Row>
          <Row>
            <Col xs={10} offset={6}>
              <DefaultSelect
                name="waitingPeriod"
                onChange={(e) => {
                  setWaitingPeriodValue(e)
                }}
                label={translate('admin-dashboard.benefit-details.summary.class-waiting-period')}
                className="width_100"
                items={waitingPeriodOptions}
              ></DefaultSelect>
            </Col>
          </Row>
        </form>
      )}
    </Formik>
  )
}

export default GroupHealthPlanInformation
